<template>
	<Pupup v-if="isVisible" @close="handleCancel" :showClose="true" :width="500" :title="title">
		<template v-slot:content>
			<div class="confirm-dialog-content">
				<p v-html="message"></p>

				<div class="button-wrap">
					<button class="button mini flip-colours" @click="handleConfirm">
						{{ confirmText }}
					</button>
					<button v-if="cancelText" class="button mini hollow" @click="handleCancel">
						{{ cancelText }}
					</button>
				</div>
			</div>
		</template>
	</Pupup>
</template>

<script>
import { ref } from "vue";
import Pupup from "./Pupup.vue";

export default {
	name: "ConfirmDialog",
	components: {
		Pupup,
	},
	setup() {
		const isVisible = ref(false);
		const title = ref("Confirm");
		const message = ref("");
		const confirmText = ref("OK");
		const cancelText = ref("Cancel");
		let resolveCallback = null;
		let rejectCallback = null;

		const show = (options = {}) => {
			return new Promise((resolve, reject) => {
				title.value = options.title || "Confirm";
				message.value = options.message || "Are you sure?";
				confirmText.value = options.okText || "OK";
				cancelText.value = options.cancelText || "Cancel";
				resolveCallback = resolve;
				rejectCallback = reject;
				isVisible.value = true;
			});
		};

		const handleConfirm = () => {
			isVisible.value = false;
			if (resolveCallback) {
				resolveCallback(true);
				resolveCallback = null;
				rejectCallback = null;
			}
		};

		const handleCancel = () => {
			isVisible.value = false;
			if (rejectCallback) {
				rejectCallback(new Error("User cancelled"));
				resolveCallback = null;
				rejectCallback = null;
			}
		};

		return {
			isVisible,
			title,
			message,
			confirmText,
			cancelText,
			show,
			handleConfirm,
			handleCancel,
		};
	},
};
</script>

<style lang="less" scoped>
@import "./../../assets/css/less/_settings.less";

.confirm-dialog-content {
	p {
		margin: 0;
		color: @darkContrast;
		line-height: 1.5;
	}

	.button-wrap {
		display: flex;
		justify-content: flex-end;
		gap: 12px;

		@media (max-width: 480px) {
			flex-direction: column-reverse;
			gap: 8px;

			.button {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>